/**
 * Способ оплаты — ровно один.
 *
 * Карта и СБП живут на черновике двумя разными полями, и это оставляет место состоянию, которого
 * быть не должно: выбрана карта И выбран СБП. Сервер такое отвергает («укажите ровно один способ
 * оплаты»), но узнать об этом на кнопке «Оформить и оплатить» — поздно.
 *
 * Поэтому выбор делается только этими двумя правками: каждая назначает свой способ и снимает
 * другой. Присваивать `paymentMethodId` напрямую в обход — это и есть та ошибка, которую здесь
 * нечем поймать, кроме договорённости.
 */
import type { OrderDraft } from './draft';

/** «Оплата» на сводке для заказа по СБП — карты с её «•••• 1234» тут нет. */
export const SBP_LABEL = 'СБП';

export function payWithCard(id: string, label: string): Partial<OrderDraft> {
  return { paymentMethodId: id, paymentMethodLabel: label, paysWithSbp: false };
}

export function payWithSbp(): Partial<OrderDraft> {
  return { paymentMethodId: null, paymentMethodLabel: SBP_LABEL, paysWithSbp: true };
}

/** Выбран ли способ вообще — то же условие, что пускает со шага оплаты дальше. */
export function hasPaymentChoice(draft: OrderDraft): boolean {
  return draft.paymentMethodId !== null || draft.paysWithSbp;
}
